import { useLoaderData } from "react-router";
import CustomError from "@components/Error/CustomError";
import { MetaTagDescriptor } from "@components/MetaTags/MetaTags";
import { Route } from "@route-types/Videos/VideosDetailsPage/+types/VideosDetailsPage";
import VideosDetailsPageContent from "@routes/Videos/VideosDetailsPage/VideosDetailsPageContent";
import { ResponseType } from "@sphtech/web2-core/ssr";
import { HttpStatusCode } from "axios";

import { VideosDetailsPageContext } from "./utils/types";
import { fetchVideosDetailsData } from "./VideosDetailsPage.server";

/** This is the main entry point component for /videos/:slug/:id route. */
const VideosDetailsPage = (): React.ReactElement => {
  const context = useLoaderData<VideosDetailsPageContext>();

  // StatusCode is not 200
  if (context && context.statusCode !== HttpStatusCode.Ok) {
    return <CustomError statusCode={context.statusCode} />;
  }

  // Check if payload is missing
  if (typeof context?.payload === "undefined") {
    return <CustomError statusCode={HttpStatusCode.NotFound} />;
  }

  return <VideosDetailsPageContent {...context.payload.data} />;
};

export default VideosDetailsPage;

export const loader = async ({ params }: Route.LoaderArgs) => {
  return await fetchVideosDetailsData(params.slug, params.id);
};

export const meta = ({ loaderData }: Route.MetaArgs): MetaTagDescriptor[] => {
  const context = loaderData as VideosDetailsPageContext;

  if (context.type !== ResponseType.SUCCESS) return [];

  const data = context.payload;

  if (!data) return [];
  if (!data.metaTags) return [];

  return data.metaTags;
};
